import React, { useContext, useEffect, useRef, useState } from "react";
import PopupModal from "../../PopupModal";
import { Box, Button, Checkbox } from "@mui/material";
import { FaCheck, FaList } from "react-icons/fa";
import {
    useLazyGetUploadedAttachmentsQuery,
    useSelectElementAttachmentMutation,
} from "modules/pvs_activities/redux/service/formAttachments";
import { FormDataContext } from "../../contexts/FormContext";
import moment from "moment";
import { displayNotification, toggleValueInArray } from "helpers";

const defaultProps = {
    elementId: "",
    selected: [],
    onChange: () => {},
};

const SelectUploadedAttachmentModal = (rawProps) => {
    const props = {...defaultProps, ...rawProps};

    const modalRef = useRef();
    const formDataContext = useContext(FormDataContext);

    const [trigger, res] = useLazyGetUploadedAttachmentsQuery();
    const [selectElementAttachment, selectAttachmentRes] = useSelectElementAttachmentMutation();
    const [selected, setSelected] = useState([]);

    useEffect(() => {
        if (selectAttachmentRes.isError) {
            displayNotification("success", "Error selecting a uploaded document.");
            console.error({ error: selectAttachmentRes.error });
        }
        if (selectAttachmentRes.isSuccess) {
            displayNotification("success", "Successfully selected a uploaded document.");
            modalRef.current?.closeModal();
        }
    }, [selectAttachmentRes]);

    const handleSelection = () => {
        if (window.confirm("You are about to select a document. Are you sure?")) {
            if (formDataContext.mode === "preview") {
                displayNotification("success", "Successfully selected a uploaded document.");
                modalRef.current?.closeModal();
                return;
            }
            selectElementAttachment({
                template_id: formDataContext.templateId,
                section_id: formDataContext.sectionId,
                element_id: props.elementId,
                movement_id: formDataContext.movementId,
                document_ids: selected,
            });
        }
    };

    const handleReset = () => {
        setSelected([]);
    };

    return (
        <PopupModal
            ref={modalRef}
            title="Select from uploaded documents"
            size="xl"
            triggers={({openModal}) => (
                <Button variant={"contained"} color="primary" sx={{ my: "auto" }} onClick={openModal}>
                    <FaList />
                    <span className="ms-1">Select from uploaded documents</span>
                </Button>
            )}
            onOpen={() => {
                if (formDataContext.mode === "data_entry") {
                    trigger({
                        movementId: formDataContext.movementId,
                        exceptIds: props.selected.join(","),
                    });
                }
            }}
            onClose={handleReset}
        >
            <>
                <table className="table table-bordered">
                    <thead className="bg-primary text-white">
                        <tr>
                            <th width="50" className="text-center"></th>
                            <th width="50" className="text-center">
                                #
                            </th>
                            <th className="text-center">Evidence #</th>
                            <th>Label</th>
                            <th>Document Name</th>
                            <th>Category Name</th>
                            <th>Sub-Category Name</th>
                        </tr>
                    </thead>
                    <tbody>
                        {formDataContext.mode === "preview" ? (
                            <>
                                <tr>
                                    <td className="text-center">
                                        <Checkbox
                                            value={"random-id"}
                                            checked={selected.includes("random-id")}
                                            onChange={() => setSelected(toggleValueInArray(selected, "random-id"))}
                                        />
                                    </td>
                                    <td className="text-center">1</td>
                                    <td className="text-center">E01</td>
                                    <td>Label Here</td>
                                    <td>abc.jpg</td>
                                    <td>Category Name here</td>
                                    <td>Sub-Category Name here</td>
                                </tr>
                                <tr>
                                    <td className="text-center">
                                        <Checkbox
                                            value={"random-id-1"}
                                            checked={selected.includes("random-id-1")}
                                            onChange={() => setSelected(toggleValueInArray(selected, "random-id-1"))}
                                        />
                                    </td>
                                    <td className="text-center">2</td>
                                    <td className="text-center">E02</td>
                                    <td>
                                        <div>Label Here</div>
                                        <div>
                                            <strong className="me-1">Ref #:</strong>
                                            <span>Ref-123/456</span>
                                        </div>
                                        <div>
                                            <strong className="me-1">Date:</strong>
                                            <span>{moment().format("DD-MMM-YY")}</span>
                                        </div>
                                    </td>
                                    <td>abc.jpg</td>
                                    <td>Category Name here</td>
                                    <td>Sub-Category Name here</td>
                                </tr>
                            </>
                        ) : res.isError ? (
                            <tr>
                                <td colSpan={7} className="text-center">
                                    Error Loading Data.
                                </td>
                            </tr>
                        ) : res.isLoading ? (
                            <tr>
                                <td colSpan={7} className="text-center">
                                    Loading Data...
                                </td>
                            </tr>
                        ) : res.isSuccess ? (
                            res.data.length > 0 ? (
                                res.data.map((r, k) => (
                                    <tr key={r.id}>
                                        <td className="text-center">
                                            <Checkbox
                                                value={r.id}
                                                checked={selected.includes(r.id)}
                                                onChange={() => setSelected(toggleValueInArray(selected, r.id))}
                                            />
                                        </td>
                                        <td className="text-center">{k + 1}</td>
                                        <td className="text-center">{r.evidence_no}</td>
                                        <td>
                                            <div>{r.label}</div>
                                            {r.is_letter === true && (
                                                <>
                                                    <div>
                                                        <strong className="me-1">Ref #:</strong>
                                                        <span>{r.ref_no}</span>
                                                    </div>
                                                    <div>
                                                        <strong className="me-1">Date:</strong>
                                                        <span>{r.file_date_formatted}</span>
                                                    </div>
                                                </>
                                            )}
                                        </td>
                                        <td>{r.actual_name}</td>
                                        <td>{r.category_name}</td>
                                        <td>{r.subcategory_name}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={7} className="text-center">
                                        No Data Found
                                    </td>
                                </tr>
                            )
                        ) : (
                            ""
                        )}
                    </tbody>
                </table>
                <Box sx={{ display: "flex", justifyContent: "end" }}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSelection}
                        disabled={selected.length === 0}
                    >
                        <FaCheck />
                        <span className="ms-1">Select & Continue</span>
                    </Button>
                </Box>
            </>
        </PopupModal>
    );
};

export default SelectUploadedAttachmentModal;
